// this is the file that contains the API configuration
// this might need to change according to the environment

const TIMEOUT = 5000
// const HOST = 'http://192.168.99.112:8080'
// const HOST = 'https://prod-api.dagang.luxtag.xfero.xyz'
const HOST = 'https://api.staging.dagang.luxtag.io'

const config = {
  timeout: TIMEOUT,
  host: HOST
}

export default config
